import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;
export const refreshSession = () => {
  if (!refreshing) {
    refreshing = axios.post(`${API}/auth/refresh`, {}, { withCredentials: true }).finally(() => {
      refreshing = null;
    });
  }
  return refreshing;
};

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config;
    const url = cfg?.url || "";
    if (error.response?.status === 401 && !cfg._retry && !url.includes("/auth/")) {
      cfg._retry = true;
      try {
        await refreshSession();
        return api(cfg);
      } catch (e) {
        window.dispatchEvent(new Event("ssp-logout"));
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const errMsg = (e) => formatApiErrorDetail(e?.response?.data?.detail) || e.message;

export async function streamSSE(path, { body, formData, onEvent, signal }) {
  await refreshSession().catch(() => {});
  const res = await fetch(`${API}${path}`, {
    method: "POST",
    credentials: "include",
    headers: formData ? undefined : { "Content-Type": "application/json" },
    body: formData || JSON.stringify(body),
    signal,
  });
  if (!res.ok) {
    let d;
    try {
      d = (await res.json()).detail;
    } catch (_) {}
    throw new Error(formatApiErrorDetail(d));
  }
  const reader = res.body.getReader();
  const dec = new TextDecoder();
  let buf = "";
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    buf += dec.decode(value, { stream: true });
    let idx;
    while ((idx = buf.indexOf("\n\n")) >= 0) {
      const chunk = buf.slice(0, idx);
      buf = buf.slice(idx + 2);
      const data = chunk
        .split("\n")
        .filter((l) => l.startsWith("data: "))
        .map((l) => l.slice(6))
        .join("");
      if (data) onEvent(JSON.parse(data));
    }
  }
}

export async function downloadBlob(path, filename) {
  const res = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
}

export const fmtDate = (iso) =>
  iso ? new Date(iso).toLocaleDateString(undefined, { day: "numeric", month: "short", year: "numeric" }) : "—";

export const PRODUCT_TYPES = [
  { value: "book", label: "Book" },
  { value: "guide", label: "Guide" },
  { value: "workbook", label: "Workbook" },
  { value: "short-stories", label: "Short stories" },
  { value: "other", label: "Other digital product" },
];
